import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import { LinkProps } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Button, { ButtonProps } from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Settings from '@material-ui/icons/Settings';
import HashLink from '../Common/HashLink';
import QuizRow from './QuizRow';

const jss = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    links: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '20px',
    },
    settingsIcon: {
        borderRadius: '5px',
        backgroundColor: theme.palette.grey[300],
        '&:hover': {
            backgroundColor: theme.palette.grey[400],
        },
        color: theme.palette.primary.main,
    },
    list: {
        width: '100%',
    },
    listItem: {
        borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
        borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    },
});

interface Props {
    getQuizzes: (params: Bee.Params) => Promise<any>
    publishQuiz: (id: string) => any;
    unpublishQuiz: (id: string) => any;
    deleteQuiz: (id: string) => any;
    match: {
        path: string;
    };
    history: {
        push: (path: string, state?: any) => void;
    };
    location: {
        hash: string;
    }
    classes: {
        container: string;
        links: string;
        settingsIcon: string;
        list: string;
        listItem: string;
    };
}

interface State {
    quizzes: Bee.Quiz[];
}

class AdminPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            quizzes: [],
        };
    }

    componentDidMount() {
        this.onMount();
    }

    private onMount = async () => {
        const data = await this.props.getQuizzes({
            index: 'state-startTime',
        });
        if (data && data.results) {
            this.setState({ quizzes: data.results });
        }
    }

    private onPublish = async (uid: string) => {
        const data = await this.props.publishQuiz(uid);
        if (data !== undefined) {
			const quizzes = this.state.quizzes.map(quiz => {
				if (quiz.id === uid) {
					return { ...quiz, state: 'pending' };
				}
				return quiz;
			});
            this.setState({ quizzes });
        }
    }

    private onUnpublish = async (uid: string) => {
        const data = await this.props.unpublishQuiz(uid);
        if (data !== undefined) {
			const quizzes = this.state.quizzes.map(quiz => {
				if (quiz.id === uid) {
					return { ...quiz, state: 'created' };
				}
				return quiz;
			});
			this.setState({ quizzes });	
		}
    }

    private onDelete = async (uid: string) => {
        const data = await this.props.deleteQuiz(uid);
        if (data !== undefined) {
			const quizzes = this.state.quizzes.filter(quiz => quiz.id !== uid);
			this.setState({ quizzes });
		}
    }

    private onEdit = async (quiz: Bee.Quiz) => {
        this.props.history.push(`${this.props.match.path}/edit/${quiz.id}${this.props.location.hash}`)
    }

  	render() {
        const { classes } = this.props;
        
        const CreateLink = (props: LinkProps & ButtonProps)  => <HashLink to={`${this.props.match.path}/create`} {...props} />
        const SettingsLink = (props: LinkProps & ButtonProps)  => <HashLink to={`${this.props.match.path}/settings`} {...props} />

        return (
            <div className={classes.container}>
                <div className={classes.links}>
                    <Button
                        variant="contained"
                        color="primary"
                        component={CreateLink}
                    >
                        <Typography variant="subtitle1" color="inherit">New Quiz</Typography>
                    </Button>
                    <IconButton
                        color="primary"
                        component={SettingsLink}
                        className={classes.settingsIcon}
                    >
                        <Settings color="inherit" />
                    </IconButton>
                </div>
                <List className={classes.list}>
                    <Divider />
                    {this.state.quizzes.map(row => (
                        <QuizRow
                            key={row.id}
                            quiz={row}
                            link={`${this.props.match.path}/view/${row.id}`}
                            publish={this.onPublish}
                            unpublish={this.onUnpublish}
                            delete={this.onDelete}
                            edit={this.onEdit}
                        />
                    ))}
                </List>
            </div>
        )
	}
}

export default withStyles(jss)(AdminPage);



// WEBPACK FOOTER //
// ./src/components/Admin/AdminPage.tsx